import { apiUrl, authHeaders } from './auth';

const redeemMyId = async (campaignId: string) => {
  const headers = authHeaders();
  const url = apiUrl + '/hhl/myid';

  const resp = await fetch(url, {
    method: 'POST',
    headers,
    body: JSON.stringify({ campaign_id: campaignId }),
  });

  if (!resp.ok) {
    const errorDetails = await resp.json();
    const error = new Error(errorDetails.error || 'An error occurred');
    throw error;
  }

  const json = await resp.json();
  return json;
};

const checkRedemption = async (campaignId: string) => {
  const headers = authHeaders();
  const url = apiUrl + '/hhl/myid/checkRedemption';

  const resp = await fetch(url, {
    method: 'POST',
    headers,
    body: JSON.stringify({ campaign_id: campaignId }),
  });

  if (!resp.ok) {
    const errorDetails = await resp.json();
    const error = new Error(errorDetails.error || 'An error occurred');
    throw error;
  }

  const json = await resp.json();
  return json;
};

export { redeemMyId, checkRedemption };
